import script from "./TermsOfUse.vue?vue&type=script&lang=ts&setup=true"
export * from "./TermsOfUse.vue?vue&type=script&lang=ts&setup=true"

import "./TermsOfUse.vue?vue&type=style&index=0&id=8c88919c&lang=scss&scoped=true"
import "./TermsOfUse.vue?vue&type=style&index=1&id=8c88919c&lang=scss"

import exportComponent from "D:\\a\\1\\s\\TelAvivMuseum.Web\\museum-telaviv\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c88919c"]])

export default __exports__